import { Auth } from "vue-app-utils-web";
import { useAppStore } from "@/store";
import { connectAuthEmulator } from "firebase/auth";

const auth = new Auth();

if (import.meta.env.VITE_NODE_ENV === "development") {
  const port = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_PORT || "9099";
  connectAuthEmulator(auth.auth, `http://127.0.0.1:${port}`);
}

export function configureAuth (router, session, dialog) {
  const store = useAppStore();
  auth.configure(router, store, session, dialog, [
    "phone",
    { provider: "anonymous", hidden: true }
  ]);
}

export default auth;